// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WYqOHCiGlWGCYs {
  position: relative;
  width: 768px;
  height: 512px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 3px);
  background-attachment: scroll;
  background-color: var(--ds-surface, #ffffff);
  background-repeat: no-repeat;
  background-size: contain;
  background-position-x: right;
  background-position-y: top;
}
.WYqOHCiGlWGCYs > div {
  height: 100%;
}
.BkW6wxYKd5un2x {
  position: absolute;
  z-index: 1;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
}
.BkW6wxYKd5un2x .xgsLHaZc3tXs2C {
  margin: var(--ds-space-075, 6px);
}
.q8K5J9mxSftrGc {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  min-height: 328px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 50%;
  padding-left: var(--ds-space-400, 32px);
  overflow-y: auto;
}
.q8K5J9mxSftrGc .O1rF3bio0edqr6 {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.q8K5J9mxSftrGc .Rlb9WgparWFlb7 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 30px;
}
.q8K5J9mxSftrGc .Rlb9WgparWFlb7 button {
  margin-right: var(--ds-space-100, 8px);
}
.dLwUBFvfKm6_P8 {
  word-wrap: break-word;
}
.PMgb05VcHU42gH {
  padding-bottom: var(--ds-space-200, 16px);
}
.q0mg_bInRcfoDn {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin: var(--ds-space-0, 0);
  overflow: hidden;
  font-weight: var(--ds-font-weight-medium, 500);
  text-overflow: ellipsis;
}
.kEl3VSiNv8LdoK {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  max-width: 50%;
}
.uuDPhDz_WWxQaV {
  display: none;
}
@media only screen and (max-width: 750px) {
  .WYqOHCiGlWGCYs {
    width: 510px;
    max-width: 100vw;
    height: auto;
    min-height: 512px;
    padding: var(--ds-space-0, 0);
    /* stylelint-disable-next-line declaration-no-important */
    background-image: none !important;
  }
  .WYqOHCiGlWGCYs > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
  .q8K5J9mxSftrGc {
    display: block;
    margin-right: var(--ds-space-0, 0);
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    padding: 36px var(--ds-space-300, 24px);
  }
  .w3QoAQzw7BZwZe {
    width: 100%;
    min-width: 375px;
  }
  .kEl3VSiNv8LdoK {
    display: none;
  }
  .uuDPhDz_WWxQaV {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    overflow: hidden;
  }
}
.zuszLDvtXvjZEA {
  position: absolute;
  z-index: 100;
  top: 207px;
  right: 42px;
  width: 200px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 28px var(--ds-space-100, 8px) 28px 78px;
  overflow: hidden;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 4px);
  background: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  text-overflow: ellipsis;
}
.zuszLDvtXvjZEA .aiO3fFZhT0TM75,
.zuszLDvtXvjZEA .V8w8GNMz5QGs1U {
  max-width: 100%;
  margin-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.zuszLDvtXvjZEA .aiO3fFZhT0TM75 {
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
  letter-spacing: 0.256px;
  line-height: 20px;
}
.zuszLDvtXvjZEA .V8w8GNMz5QGs1U {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-medium, 500);
  letter-spacing: 0.256px;
  line-height: 16px;
}
.zuszLDvtXvjZEA .B0TLWU4IEGkd1D {
  position: absolute;
  top: 50%;
  left: var(--ds-space-150, 11px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: -28px;
}
.zuszLDvtXvjZEA .B0TLWU4IEGkd1D > * {
  position: absolute;
  z-index: 1;
}
.zuszLDvtXvjZEA .B0TLWU4IEGkd1D .wkljIuoU_5xKR5 {
  z-index: 2;
}
.ZezfFvCLUlAQ79 {
  margin-top: var(--ds-space-200, 16px);
}
.ZezfFvCLUlAQ79 button {
  margin-right: var(--ds-space-200, 16px);
}
.DHMbAGhjLtWZ6x {
  display: inline-block;
  margin-left: var(--ds-space-200, 16px);
}
@media only screen and (max-width: 750px) {
  .zuszLDvtXvjZEA {
    top: 66px;
    right: 18%;
    left: 18%;
    width: auto;
    min-height: 30px;
    /* stylelint-disable-next-line design-system/ensure-design-token-usage */
    padding: var(--ds-space-250, 18px) var(--ds-space-100, 8px) var(--ds-space-250, 18px) 78px;
  }
}
@media only screen and (max-width: 450px) {
  .zuszLDvtXvjZEA {
    right: 8%;
    left: 8%;
  }
}
`, ""]);
// Exports
export var dialog = `WYqOHCiGlWGCYs`;
export var controls = `BkW6wxYKd5un2x`;
export var closeButton = `xgsLHaZc3tXs2C`;
export var content = `q8K5J9mxSftrGc`;
export var description = `O1rF3bio0edqr6`;
export var buttons = `Rlb9WgparWFlb7`;
export var breakable = `dLwUBFvfKm6_P8`;
export var header = `PMgb05VcHU42gH`;
export var title = `q0mg_bInRcfoDn`;
export var illustrationFull = `kEl3VSiNv8LdoK`;
export var illustrationMobile = `uuDPhDz_WWxQaV`;
export var illustration = `w3QoAQzw7BZwZe`;
export var profileInformation = `zuszLDvtXvjZEA`;
export var atlassianProfileName = `aiO3fFZhT0TM75`;
export var atlassianProfileEmail = `V8w8GNMz5QGs1U`;
export var avatar = `B0TLWU4IEGkd1D`;
export var atlassianProfileAvatar = `wkljIuoU_5xKR5`;
export var buttonSection = `ZezfFvCLUlAQ79`;
export var spinner = `DHMbAGhjLtWZ6x`;
export default ___CSS_LOADER_EXPORT___;
